<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16.5 5h3a.5.5 0 000-1h-3a.5.5 0 000 1zM19.5 7.5h-3a.5.5 0 000 1h3a.5.5 0 000-1zM19.5 11h-3a.5.5 0 000 1h3a.5.5 0 000-1zM11 13.71V8H9v5.71a2.5 2.5 0 102 0z"/><path d="M14 11.55V6a4 4 0 00-8 0v5.55A5.93 5.93 0 004 16a6 6 0 0012 0 5.93 5.93 0 00-2-4.45zM10 20a4 4 0 01-2.4-7.18l.4-.3V6a2 2 0 014 0v6.52l.4.3A4 4 0 0110 20z"/></svg>